'use strict';

module.exports = {
  CONTAINER_HEIGHT_SCALE_FACTOR: 'containerHeightScaleFactor'
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-infinite/build/utils/scaleEnum.js
 ** module id = 450
 ** module chunks = 0
 **/